import React, { ComponentProps, useState } from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { TextInput } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface TextInputProps
  extends Omit<ComponentProps<typeof TextInput>, "required"> {
  required?: "true" | "false";
}

const Index = ({
  label = "",
  value = "",
  placeholder = "",
  required = "false",
  type = "text",
  name,
  inputId
}: TextInputProps) => {
  const [inputValue, setInputValue] = useState(value);

  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <TextInput
        {...{
          label,
          value: inputValue,
          placeholder,
          changeValue: (e: React.ChangeEvent<HTMLInputElement>) =>
            setInputValue(e.target.value),
          required: JSON.parse(required),
          type,
          name,
          inputId
        }}
      />
    </ThemeProvider>
  );
};

Index.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.oneOf(["true", "false"]),
  name: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired
};

customElements.define(
  "ibinder-text-input",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
